import $ from 'legacy/jquery';

// Scrolls smoothly to the first occurrence of the given class.
export const scrollToClass = (
  className,
  scrollTargetSelector = 'html, body'
) => {
  // Subtract a fixed amount since most pages have a fixed header.
  // This also helps give some breathing room between the top of
  // the window and the element being scrolled to.
  const scrollPosition = $(`.${className}:first`).offset().top - 100;

  $(scrollTargetSelector).animate({ scrollTop: scrollPosition }, 'fast');
};
